import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { colors } from '@skyslope/mache';
import classNames from 'classnames';

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
  },
  square: {
    height: '16px',
    width: '18px',
    lineHeight: '16px',
    position: 'relative',
    backgroundColor: colors.grey[500],
    fontSize: '12px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  squareBlue: {
    backgroundColor: colors.blue[800],
    color: 'white',
  },
  squareGreen: {
    backgroundColor: '#1eb25e',
    color: 'white',
  },
  triangle: {
    borderColor: `transparent transparent transparent ${colors.grey[500]}`,
    borderStyle: 'solid',
    borderWidth: '8px 0 8px 8px',
  },
  triangleBlue: {
    borderLeftColor: colors.blue[800],
  },
  triangleGreen: {
    borderLeftColor: '#1eb25e',
  },
}));

interface IProps {
  color?: 'green' | 'blue';
  children?: any;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const Tag = (props: IProps) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <div
        className={classNames(classes.square, {
          [classes.squareBlue]: props.color === 'blue',
          [classes.squareGreen]: props.color === 'green',
        })}
      >
        {props.children}
      </div>
      <div
        className={classNames(classes.triangle, {
          [classes.triangleBlue]: props.color === 'blue',
          [classes.triangleGreen]: props.color === 'green',
        })}
      />
    </div>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default Tag;
